import React from 'react';
import { Button, PrimaryButton } from 'glints-aries/lib/@next';
import { FormattedMessage, useIntl } from 'react-intl';

import { StringUtils } from 'src/common/utils/stringUtils';
import { JobSource } from 'src/modules/Opportunity/interface';

import * as S from './LeaveGlintsConfirmation.sc';

type TrackingParams = {
  jobId: string;
  formattedJobType?: string;
  companyId?: string;
  companyName?: string;
  jobSource?: JobSource;
  jobCategoryName?: string;
  jobSubCategoryName?: string;
  jobRoleName?: string;
  jobCategoryId?: string;
  jobSubCategoryId?: string;
  jobRoleCategoryId?: string;
};

interface Props {
  isOpen: boolean;
  handleConfirmLeaveGlints: () => void;
  handleCancelLeaveGlints: () => void;
  trackingParams: TrackingParams;
}

export default function LeaveGlintsConfirmation({
  isOpen,
  handleConfirmLeaveGlints,
  handleCancelLeaveGlints,
  trackingParams,
}: Props) {
  const { formatMessage } = useIntl();

  const customActions = (
    <S.ActionContainer>
      <Button
        onClick={handleCancelLeaveGlints}
        data-glints-tracking-element-name="external_link_continued_canceled"
      >
        <FormattedMessage
          id="text-leave-glints-confirmation-cancel"
          defaultMessage="Cancel"
        />
      </Button>

      <PrimaryButton
        onClick={handleConfirmLeaveGlints}
        data-glints-tracking-element-name="external_link_continued"
        data-gtm-job-id={trackingParams.jobId}
        data-gtm-job-type={trackingParams.formattedJobType}
        data-gtm-company-id={trackingParams.companyId}
        data-gtm-company-name={trackingParams.companyName}
        data-gtm-job-source={StringUtils.toSnakeCase(trackingParams.jobSource)}
        data-gtm-job-category={trackingParams.jobCategoryName}
        data-gtm-job-sub-category={trackingParams.jobSubCategoryName}
        data-gtm-job-role={trackingParams.jobRoleName}
        data-glints-tracking-job-category={trackingParams.jobCategoryId}
        data-glints-tracking-job-sub-category={trackingParams.jobSubCategoryId}
        data-glints-tracking-job-role={trackingParams.jobRoleCategoryId}
      >
        <FormattedMessage
          id="text-leave-glints-confirmation-continue"
          defaultMessage="Continue to Company Site"
        />
      </PrimaryButton>
    </S.ActionContainer>
  );

  return (
    <S.LeaveGlintsConfirmationContainer
      isOpen={isOpen}
      customActions={customActions}
      header={formatMessage({
        id: 'text-leave-glints-confirmation-title',
        defaultMessage: 'You are leaving Glints',
      })}
      onClose={handleCancelLeaveGlints}
    >
      <FormattedMessage
        id="text-leave-glints-confirmation-description"
        defaultMessage="You are about to leave the app to apply for this job on an external website. Would you like to proceed?"
      />
    </S.LeaveGlintsConfirmationContainer>
  );
}
